import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Dialog from '~src/shared/dialogs/dialog/Dialog';
import { OkrLabel } from '~src/store/okrs/interfaces';

import { LabelContainer, LabelSelectorContainer, LabelsWrapper, TriggerButton } from './labelSelector.sc';
import LabelSelectorForm from './LabelSelectorForm';
import LabelElement from './LabelElement';

interface Props {
  frozen?: boolean;
  onChange: (labels: OkrLabel[]) => void;
  labels: OkrLabel[];
}

const LabelSelector: FC<Props> = props => {
  const [modal, setModal] = useState(false);

  const showModal = () => setModal(true);

  const hideModal = () => setModal(false);

  const [t] = useTranslation();

  const saveLabels = (newLabels: OkrLabel[]) => {
    props.onChange(newLabels);
  };

  const remove = (label: OkrLabel) => {
    props.onChange(props.labels.filter(listLabel => listLabel.id !== label.id));
  };

  const buttonTextKey = `x.label.sector.button.text.${
    props.frozen ? 'simple' : props.labels.length > 0 ? 'edit' : 'add'
  }`;

  return (
    <LabelSelectorContainer>
      <Dialog show={modal} onHide={hideModal}>
        <LabelSelectorForm isShown={modal} save={saveLabels} hide={hideModal} labels={props.labels} />
      </Dialog>
      {props.labels.length > 0 && (
        <LabelsWrapper>
          {props.labels.map(label => (
            <LabelContainer key={label.id}>
              <LabelElement type={props.frozen ? 'fixed' : 'closed'} label={label} add={remove} />
            </LabelContainer>
          ))}
        </LabelsWrapper>
      )}
      {(!props.frozen || props.labels.length < 1) && (
        <TriggerButton
          $frozen={props.frozen}
          data-translation={buttonTextKey}
          onClick={props.frozen ? undefined : showModal}
        >
          {t(buttonTextKey)}
        </TriggerButton>
      )}
    </LabelSelectorContainer>
  );
};

export default LabelSelector;
